import React from 'react';
import { Box } from 'theme-ui';

const AspectRatio = ({ ratio, sx = {}, children }) => {
  // Calculate the padding based on ratio with support for arrays
  let paddingBottom;
  if (Array.isArray(ratio)) {
    paddingBottom = [];
    ratio.forEach((ratio) => {
      paddingBottom.push(100 / ratio + '%');
    });
  } else {
    paddingBottom = 100 / ratio + '%';
  }

  return (
    <Box
      sx={{
        ...sx,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: 0,
          paddingBottom: paddingBottom,
        }}
      />
      <Box
        as="figure"
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default AspectRatio;
